export const actions = {
  SERVICE_CHOSEN_ID_SET: 'SERVICE_CHOSEN_ID_SET',
  SERVICE_CHOSEN_IDS_CLEARED: 'SERVICE_CHOSEN_IDS_CLEARED',
}

export const setServiceChosenId = payload => ({ type: actions.SERVICE_CHOSEN_ID_SET, payload })
export const clearServiceChosenIds = () => ({ type: actions.SERVICE_CHOSEN_IDS_CLEARED })

export default actions
